export enum PIBannerStatus {
    TEASER = 'teaser',
    ACTIVITY = 'activity',
}

export type BannerItemType = {
    title: string;
    subtitle: string;
    link?: string;
    status?: PIBannerStatus;
    visible?: boolean;
};

const bannerConf = {
    teaser: {
        us: {
            title: 'EcoFlow Prime Day Sale is Coming Soon!',
            subtitle: "Mark July 1st, and don't miss the year's biggest deals!",
        },
        ca: {
            title: 'EcoFlow Prime Day Sale is Coming Soon!',
            subtitle: "Mark July 1st, and don't miss the year's biggest deals!",
        },
    },
    activity: {
        us: {
            title: 'EcoFlow Prime Day Sale (July 1-23)',
            subtitle: 'Up to $2,899 Off',
            link: 'https://us.ecoflow.com/pages/prime-day',
        },
        ca: {
            title: 'EcoFlow Prime Day Sale (July 1-23)',
            subtitle: 'Up to $2,398 Off',
            link: 'https://ca.ecoflow.com/pages/prime-day',
        },
    },
};

export const timeLine = {
    teaser: {
        start: new Date('2024/06/21 15:00:00 GMT+8').getTime(),
        end: new Date('2024/07/01 15:00:00 GMT+8').getTime(),
    },
    activity: {
        start: new Date('2024/07/01 15:00:00 GMT+8').getTime(),
        end: new Date('2024/07/24 15:00:00 GMT+8').getTime(),
    },
};

export const isInTimeRange = (currentTime: number) => {
    if (currentTime >= timeLine.teaser.start && currentTime <= timeLine.teaser.end) {
        return PIBannerStatus.TEASER;
    } else if (currentTime >= timeLine.activity.start && currentTime <= timeLine.activity.end) {
        return PIBannerStatus.ACTIVITY;
    }

    return null;
};

export const getBannerConf = (locale: string, currentTime: number, debug?: PIBannerStatus) => {
    const data: PIBannerStatus | null = debug ? debug : isInTimeRange(currentTime);

    if (data) {
        const content: Record<string, BannerItemType> = bannerConf[data];
        const state = content[locale];

        return { ...state, ...{ status: data, visible: true } };
    }

    return { title: '', subtitle: '', status: undefined, visible: false };
};
